import React from "react";
import "./ShippingAddress.css";
import { FaCircleUser } from "react-icons/fa6";
import { FaPhoneAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { IoBusiness } from "react-icons/io5";
import { MdLocationOn } from "react-icons/md";

const ShippingAddress = ({ profile }) => {
  console.log(profile);
  return (
    <section className="shicppingSection w-100 mt-4">
      <h5>
        <FaCircleUser />
        &nbsp;{profile.name}
      </h5>
      {profile.compney_name === "undefined" &&
      profile.compney_name === undefined &&
      profile.compney_name === null &&
      profile.compney_name === "null" ? (
        <h6>
          <IoBusiness />
          &nbsp;{profile.compney_name}
        </h6>
      ) : null}
      <div className="shippingAddress">
        <MdLocationOn /> {profile.address_one + " " + profile.address_two}
        <br />
        {profile.city +
          " " +
          profile.state +
          " " +
          profile.country +
          " " +
          profile.zip_code}
      </div>
      <div className="shippingContact">
        <p>
          <FaPhoneAlt /> {profile.number}
        </p>
        <p>
          <MdEmail />
          {profile.user_email}
        </p>
      </div>
    </section>
  );
};

export default ShippingAddress;
